import { render, staticRenderFns } from "./PageTitleModular.vue?vue&type=template&id=640bfc38&scoped=true&"
import script from "./PageTitleModular.vue?vue&type=script&lang=js&"
export * from "./PageTitleModular.vue?vue&type=script&lang=js&"
import style0 from "./PageTitleModular.vue?vue&type=style&index=0&id=640bfc38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640bfc38",
  null
  
)

export default component.exports